import { type FC, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconPhone } from '@redteclab/icons'

import styles from './MediServiceFurtherInformation.module.css'

type MediServiceFurtherInformationTelephoneProps = {
  overrideContactPhone?: ReactNode
}

export const MediServiceFurtherInformationTelephone: FC<
  MediServiceFurtherInformationTelephoneProps
> = ({ overrideContactPhone }) => {
  return (
    <div className={styles['further-information-contact-details-section']}>
      <IconPhone className="size-6 text-dark-brand" />
      <div className={styles.description}>
        <span>
          <FormattedMessage id="chrx.further-info.phone-title" />
        </span>
        <span className="text-dark-primary-strong">
          {overrideContactPhone ?? (
            <FormattedMessage id="chrx.further-info.phone" />
          )}
        </span>
      </div>
    </div>
  )
}
